import { CbSelectChoiceModule } from '@chubb/ui-components/cb-select-choice';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { FraudDisclosuresComponent } from './fraud-disclosures.component';
@NgModule({
    imports: [CommonModule, CbSelectChoiceModule, SelectModule],
    declarations: [FraudDisclosuresComponent],
    exports: [FraudDisclosuresComponent],
})
export class FraudDisclosuresModule {}
